<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row align="center">
            <v-col cols="12" sm="4">
                <v-btn
                    block
                    color="primary"
                    href="/admin/new-page"
                >{{$t('Añadir nuevo')}}</v-btn>
            </v-col>
            <v-col cols="12" sm="8">
                <form @submit.prevent="processSearch" style="width:100%" class="d-flex align-center">
                    <v-text-field
                        v-model="txtSearch"
                        :label="$t('Buscar página...')"
                        outlined
                        dense
                        hide-details
                        type="text"
                    ></v-text-field>
                    <v-btn
                        color="primary"
                        type="submit"
                        elevation="2"
                        icon
                        large
                        v-show="txtSearch !== ''"
                        class="ml-2"
                    >
                        <v-icon dark>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                    <v-btn
                        color="red"
                        icon
                        large
                        v-show="txtSearch !== ''"
                        @click="cleanSearch"
                        class="ml-2"
                    >
                        <v-icon dark>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </form>
            </v-col>
        </v-row>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                {{$t('Lista de páginas')}}
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            {{$t('Título')}}
                        </th>
                        <th class="text-left">
                            {{$t('Url')}}
                        </th>
                        <th class="text-left">
                            {{$t('Estado')}}
                        </th>
                        <th class="text-right">
                            {{$t('Acciones')}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listPages" :key="index">
                        <td>{{ item.title }}</td>
                        <td>
                            <a :href="tmpSlug+slug+'/my/'+item.slug" target="_blank">{{ tmpSlug }}{{ slug }}/my/{{ item.slug }}</a>
                        </td>
                        <td>
                            <v-chip
                                :color="(item.state)?'green':'red'"
                                small
                                text-color="white"
                            >
                                {{ (item.state)?$t('Activo'):$t('Inactivo') }}
                            </v-chip>
                        </td>
                        <td class="text-right">
                            <div class="d-flex justify-end">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/edit-page/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('Editar')}}</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="deleteProduct(item.id)"
                                        >
                                            <v-icon color="grey">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('Eliminar')}}</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Páginas',
                    disabled: false,
                    href: '/admin/pages',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listPages: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
        }
    },
    props: ['slug'],
    mounted() {
        this.getListPages()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListPages()
        },
        changePage (event) {
            this.page = event;
            this.getListPages()
        },
        cleanSearch () {
            if (this.txtSearch !== '') {
                this.listPages = []
                this.page = 1
                this.txtSearch = ''
                this.getListPages();
            }
        },
        async getListPages () {
            this.overlay = true
            await axios.post(`/admin/list-pages?page=${this.page}&search=${this.txtSearch}`, {})
            .then(response => {
                // console.log(response)
                this.listPages = response.data.data
                this.totalPage = response.data.last_page
                this.pageTable = `${this.$t('Mostrando')} <strong>${response.data.from??0} - ${response.data.to??0}</strong> ${this.$t('de un total de')} <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },

        /**
         * Delete
         */
        deleteProduct (id) {
            this.$confirm(
                this.$t('Se eliminará permanentemente del sistema'),
                this.$t('¿Eliminar página?'),
                'question', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('Eliminar'),
                cancelButtonText: this.$t('Cancelar'),
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/del-page/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', this.$t('Página eliminado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                            this.getListPages()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                        }
                    })
                }
            });
        },
    },
}
</script>
